import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v2/dashboard/summary', { params });
  },
  getChart(params = {}) {
    return axios.get('/v2/dashboard/chart-spending', { params });
  },
  getPercentage(params = {}) {
    return axios.get('/v2/dashboard/summary-percentage', { params });
  },
  getQuarter(params = {}) {
    return axios.get('/v2/dashboard/chart-quarter', { params });
  },
  getCalendar(params = {}) {
    return axios.get('/v1/chart-calendar', { params });
  },
  getTopline(params = {}) {
    return axios.get('/v2/report/topline', { params });
  },
  getDashboardBo(params = {}) {
    return axios.get('/v2/dashboard/chart-spending-per-bo', { params });
  },
  searchIO(params = {}) {
    return axios.get('/v1/io/search', { params });
  }
};
